/* unplugin-vue-components disabled */import script from "./Payment copy.vue?vue&type=script&setup=true&lang=js"
export * from "./Payment copy.vue?vue&type=script&setup=true&lang=js"

import "./Payment copy.vue?vue&type=style&index=0&id=cc2170f6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc2170f6"]])

export default __exports__